<ng-container *ngIf="vm">

  <div class="year-container">

    <div class="week-container mr-5">
      <div *ngIf="mode === 'month'"
           class="week-day-index"></div>
      <div *ngFor="let rowLabel of vm.rowLabels"
           class="week-day-index">
        {{ rowLabel }}
      </div>
    </div>

    <div *ngFor="let week of vm.data; let columnIndex = index"
         class="week-container">
      <ng-container *ngFor="let day of week; let last = last; let first = first">
        <div *ngIf="mode === 'month' && first"
             class="week-container">
          <div class="week-day-month">
            {{ vm.columnLabels[columnIndex] }}
          </div>
        </div>
        <div [title]="day.date | date"
             class="week-day"
             style="background-color: rgba(45, 192, 153, {{iHateAlpha(day.charCount)}})"
             (click)="dayClicked.emit(day.date)">
<!--          {{ day.date | date: 'd' }}-->
        </div>
        <div *ngIf="mode === 'week' && last"
             class="week-container">
          <div class="week-day-month">
            {{ vm.columnLabels[columnIndex] }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>

</ng-container>
